import React, { useEffect, useState } from 'react';
import './About.css';
import Navbar from '../../components/Navbar/Navbar';
import Aurora from '../../components/Aurora/Aurora';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import Footer from '../../components/Footer/Footer';

const About = () => {
  const [navbarHidden, setNavbarHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const viewportHeight = window.innerHeight;

      if (currentScrollY > lastScrollY && currentScrollY > viewportHeight) {
        // Scrolling down and past 100vh (one full screen)
        setNavbarHidden(true);
      } else {
        // Scrolling up
        setNavbarHidden(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <div className="about-page">
      <Navbar className={navbarHidden ? 'hidden' : ''} />
      {/* Aurora header to match Hero navbar visuals */}
      <div className="about-aurora hero-section">
        <div className="aurora-wrapper">
          <Aurora
            colorStops={["#0088FF", "#4ecdc4", "#1E40AF"]}
            blend={0.8}
            amplitude={1.2}
            speed={0.3}
          />
        </div>
      </div>

      {/* Hero Section */}
      <section className="about-hero hero-section">
        <div className="about-hero-container">
          <div className="about-hero-content">
            <h1 className="about-hero-title">About MyDigitalSchools</h1>
            <p className="about-hero-subtitle">
              Empowering education through innovative digital solutions and comprehensive learning platforms.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="about-mission">
        <div className="about-container">
          <div className="mission-content">
            <h2 className="section-title">Our Mission</h2>
            <p className="mission-text">
              At MyDigitalSchools, we believe in transforming education through technology. Our mission is to provide
              schools, teachers, and students with access to the best digital learning platforms and tools, making
              education more engaging, accessible, and effective for everyone.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-values">
        <div className="about-container">
          <h2 className="section-title">Our Values</h2>
          <div className="values-grid">
            {/* <div className="value-card">
              <div className="value-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="value-title">Excellence</h3>
              <p className="value-description">
                We strive for excellence in everything we do, ensuring the highest quality educational experiences.
              </p>
            </div> */}

            <div className="value-card">
              <div className="value-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="value-title">Collaboration</h3>
              <p className="value-description">
                We believe in the power of collaboration between educators, students, and technology partners.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="value-title">Security</h3>
              <p className="value-description">
                We prioritize the safety and security of student data and educational content.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="value-title">Innovation</h3>
              <p className="value-description">
                We continuously innovate to bring cutting-edge educational technology to classrooms.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="about-story">
        <div className="about-container">
          <div className="story-content">
            <h2 className="section-title">Our Story</h2>
            <div className="story-text">
              <p>
                MyDigitalSchools was founded with a vision to bridge the gap between traditional education and
                modern technology. We recognized that schools needed a centralized platform to access and manage
                multiple educational tools and resources.
              </p>
              <p>
                Today, we partner with leading educational technology providers to offer schools a comprehensive
                suite of learning platforms, from interactive content to assessment tools, all accessible through
                a single, secure portal.
              </p>
              <p>
                Our platform serves thousands of students and educators worldwide, helping them unlock the full
                potential of digital learning while maintaining the highest standards of educational excellence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      {/* <section className="about-stats">
        <div className="about-container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">1000+</div>
              <div className="about-stat-label">Schools</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50,000+</div>
              <div className="about-stat-label">Students</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">10,000+</div>
              <div className="about-stat-label">Teachers</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">25+</div>
              <div className="about-stat-label">Platform Partners</div>
            </div>
          </div>
        </div>
      </section> */}

      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default About;
